import React, {Component} from 'react'
import { connect } from 'react-redux';

import CommentTrashListHeader from '../../components/comments/commentTrash/CommentTrashListHeader'
import CommentTrashList from '../../components/comments/commentTrash/CommentTrashList'
import Pagination from '../../components/common/Pagination';
import ListTitle from "../../components/common/list/ListTitle";
import { parseListParams } from '../../components/common/CommentListHelper';
import * as InitStatus from '../../constants/common/InitializationStatus';
import autobind from "autobind-decorator";

@connect(state => ({
    items: state.commentTrash.item.items,
    totalCount: state.commentTrash.item.totalCount,
    searchKeyword: state.commentTrash.condition.searchKeyword,
}))
class CommentApp extends Component {

    constructor(props){
      super(props);
      this.state = {headerStatus : InitStatus.INIT_READY}
    }

    // Header process 상태
    @autobind
    handleSetHeaderStatus(status){
      this.setState({headerStatus : status});
    }

    render() {
        const { totalCount, searchKeyword } = this.props;
        const {headerStatus} = this.state;

        return (
				<div className="inner_article reply_article">
					<h2 id="kakaoBody" className="screen_out">티스토리 관리센터 본문</h2>
					<ListTitle headTitle="댓글 휴지통" totalCount={totalCount} searchKeyword={searchKeyword}/>
					<CommentTrashListHeader handleSetHeaderStatus={this.handleSetHeaderStatus}/>
					<CommentTrashList headerStatus={headerStatus}/>
					<Pagination totalCount={totalCount} parseListParams={parseListParams}/>
				</div>
        )
    }
}

export default CommentApp;
